import 'arrive';
import $ from 'jquery';

document.arrive('.main-news-page', { existing: true }, function () {

    document.querySelectorAll(".single-article__cover img").forEach(img => {
        if (img.complete) {
        checkOrientation(img);
        } else {
        img.addEventListener("load", () => checkOrientation(img));
        }
    });

    function checkOrientation(img) {
        const container = img.closest(".single-article__cover");
        if (!container) return;

        if (img.naturalHeight > img.naturalWidth) {
        container.classList.add("portrait");
        container.classList.remove("landscape");
        } else {
        container.classList.add("landscape");
        container.classList.remove("portrait");
        }
    }

    // Gestione hover tramite .hover-area: mostra/nascondi la cover
    document.querySelectorAll('.single-article').forEach(article => {
        const hoverArea = article.querySelector('.hover-area');
        const cover = article.querySelector('.single-article__cover');
        if (!hoverArea || !cover) return;

        const show = () => {
            cover.classList.add('is-visible');
            cover.style.opacity = '1';
        };
        const hide = () => {
            cover.classList.remove('is-visible');
            cover.style.opacity = '';
        };

        hoverArea.addEventListener('mouseenter', show);
        hoverArea.addEventListener('mouseleave', hide);
        // Touch support: tap per mostrare, tap fuori per nascondere
        hoverArea.addEventListener('touchstart', show, { passive: true });
        document.addEventListener('touchstart', (e) => {
            if (!article.contains(e.target)) hide();
        }, { passive: true });
    });

});